import { useMemo } from "react";
function* counter() {
    let count = 0;
    while (true) {
        count += 1;
        yield count;
    }
}
const idGenerator = counter();
const generateId = () => idGenerator.next().value;
/**
 * Replacement for `useId` hook shipped with React 18. This is meant to be removed once we will
 * migrate this repository to React 18. This API is supposed to match default useId API.
 *
 * Take a look at the
 * {@link https://reactjs.org/docs/hooks-reference.html#useid documentation of useId}
 */
export const useId = () => {
    const id = useMemo(generateId, []);
    return `:r${id.toString(32)}:`;
};
